import { capitalize, Grid } from '@mui/material'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import SidebarInitActionsSlTp from './SidebarPendingOrderSlTp'
import SidebarPnlItem from './SidebarPnlItem'
import { forexMath, getAssetNumber, handleCancelOpen, toFixedIfNull, updateSlTpOpenTrade } from '../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { selectLatestRatesBidAsk } from '../../../../../store/redusers/assets/selectors'
import { selectAccessToken } from '../../../../../store/redusers/auth/selectors'
import {
	setCancelOpenAction,
	setUpdateOpenTradeAction
} from '../../../../../store/redusers/orders/actions'
import {
	selectPositionDefaultItem,
	selectTailDigitOfCurrency
} from '../../../../../store/redusers/positions/selectors'
import {
	selectUserId,
	selectUserCurrency,
	selectMarginTradePlatform
} from '../../../../../store/redusers/user/selectors'
import AppButton from '../../../../AppButton'
import { AppOrderItem } from '../../../../AppOrderItem'
import AppPopup from '../../../../AppPopup'

function SidebarUpdateOpenTrade({ toUpdateOpenTrade }) {
	const userId = useSelector(selectUserId)
	const accessToken = useSelector(selectAccessToken)
	const {dispatch, alert, theme, t } = useDefaultComponentTools(true)
	const userCurrency = useSelector(selectUserCurrency)
	const tailDigitOfCurrency = useSelector(selectTailDigitOfCurrency)
	const myTrade = useSelector(selectPositionDefaultItem('open', toUpdateOpenTrade))
	const marginTrade = useSelector(selectMarginTradePlatform)
	const isAuthorized = useSelector(selectUserId)
	const [isShowPopup, setIsShowPopup] = useState(false)
	const [takeProfitSend, setTakeProfitSend] = useState(
		myTrade && isNaN(parseFloat(myTrade?.takeProfit)) ? -1 : parseFloat(myTrade?.takeProfit)
	)
	const [stopLossSend, setStopLossSend] = useState(
		isNaN(parseFloat(myTrade?.stopLoss)) ? -1 : parseFloat(myTrade?.stopLoss)
	)
	const [takeProfitAmount, setTakeProfitAmount] = useState(
		myTrade && (+myTrade?.takeProfit === 10000000 || +myTrade?.takeProfit === 0) ?
			'' : parseFloat(myTrade?.takeProfitAmount)
	)

	const [stopLossAmount, setStopLossAmount] = useState(
		myTrade && (+myTrade?.stopLoss === 0 || +myTrade?.stopLoss === 10000000 ) ?
			'' : parseFloat(myTrade?.stopLossAmount)
	)
	let invTitle = 'Investment'
	if (marginTrade) invTitle = 'Margin Used'
	// eslint-disable-next-line max-len
	let stopLossUpdate = myTrade && (myTrade?.stopLoss === '' || +myTrade?.stopLoss === 0 || +myTrade?.stopLoss === 10000000 ?
		'' : myTrade?.stopLoss)
	// eslint-disable-next-line max-len
	let takeProfitUpdate = myTrade && (myTrade?.takeProfit === '' || +myTrade?.takeProfit === 0 || +myTrade?.takeProfit === 10000000 ?
		'' : myTrade?.takeProfit)

	useEffect(() => {
		if (!myTrade) {
			return
		}
		if (stopLossUpdate === '' || takeProfitUpdate === '') {
			if (myTrade?.position === 'sell') {
				setStopLossSend(stopLossUpdate === '' || stopLossUpdate ? 10000000 : stopLossUpdate)
				setTakeProfitSend(takeProfitUpdate === '' ? 0 : takeProfitUpdate)
			} else {
				setStopLossSend(stopLossUpdate === '' ? 0 : stopLossUpdate)
				setTakeProfitSend(takeProfitUpdate === '' ? 10000000 : takeProfitUpdate)
			}
		}
	}, [])


	const executionDatePop = dayjs(myTrade?.executionDate).format('DD.MM.YYYY')

	const setTakeProfitAmountA = (e) => {
		if (!e || e === '') {
			setTimeout(() => {
				setTakeProfitSend(null)
			})
		}
		if (e === takeProfitAmount && !e) {
			e = ''
		}
		setTakeProfitAmount(e)
	}
	const setStopLosAmountA = (e) => {
		if (!e || e === '') {
			setTimeout(() => {
				setStopLossSend(null)
			})
		}
		if (e === stopLossAmount && !e) {
			e = ''
		}
		setStopLossAmount(e)
	}
	function updateSlTpCreateOpen(typeAmount, value){
		updateSlTpOpenTrade(
			+value,
			+myTrade?.executionEntryRate,
			myTrade?.pipValueServer,
			myTrade?.pipDecimalPlaces,
			typeAmount,
			myTrade?.position,
			tailDigitOfCurrency,
			setStopLosAmountA,
			setTakeProfitAmountA
		)
	}

	const openPrice = forexMath.formatRateForTrade(myTrade?.executionEntryRate, myTrade)
	const currentPrice = forexMath.formatRateForTrade((myTrade?.endRate != null) ?
		myTrade?.endRate : myTrade?.executionEntryRate, myTrade)
	const invValue = toFixedIfNull(myTrade?.amount, tailDigitOfCurrency)
	const tradeSize = forexMath.getTradeSizeValueStr( myTrade?.lotSize, myTrade?.leverage)
	const directionColor = myTrade?.position === 'sell' ? theme.palette.red : theme.palette.green
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk('asset_' + myTrade?.assetId))
	const bidRate = myTrade?.position === 'sell' ? latestRatesBidAsk.bid : latestRatesBidAsk.ask
	const bidUp = latestRatesBidAsk.bidUp
	const redColor = theme.palette.red
	const textColor = theme.palette.text.primary
	const greenColor = theme.palette.green

	const handleUpdateOpenTrade = async (e) => {
		e.preventDefault()
		if (stopLossSend === '') {
			if (myTrade?.position === 'sell'){
				setStopLossSend(10000000)
			} else {
				setStopLossSend(0)
			}
		}
		if (takeProfitSend === '') {
			if(myTrade?.position === 'sell'){
				setTakeProfitSend(0)
			} else {
				setTakeProfitSend(10000000)
			}
		}
		let updateData = `${
			'&stopLoss=' + stopLossSend
			+ '&takeProfit=' + takeProfitSend
		}`
		try {
			alert.info(t('Executing order')+'...', {
				loader: true,
				timeout: 0,
				title: 'Execute order'
			})
			let res = await dispatch(setUpdateOpenTradeAction(updateData, accessToken, userId, myTrade?.id, alert))
			if (res) {
				alert.removeAll()
				alert.success('Update trade data')
			}
		}
		catch (e) {
			alert.removeAll()
			'message' in e && alert.error(e.message)
		}
	}

	useEffect(() => {
		if (!myTrade) {
			return
		}
		const tempTakeProfitAmount = (+myTrade?.takeProfit === 10000000 || +myTrade?.takeProfit === 0) ?
			'' : parseFloat(myTrade?.takeProfitAmount)
		const tempStopLossAmount = (+myTrade?.stopLoss === 0 || +myTrade?.stopLoss === 10000000 ) ?
			'' : parseFloat(myTrade?.stopLossAmount)
		const tempSendTPValue = isNaN(parseFloat(myTrade?.takeProfit)) ? -1 : parseFloat(myTrade?.takeProfit)
		const tempSendSLValue = isNaN(parseFloat(myTrade?.stopLoss)) ? -1 : parseFloat(myTrade?.stopLoss)
		setTakeProfitAmount(tempTakeProfitAmount)
		setStopLossAmount(tempStopLossAmount)
		setStopLossSend(tempSendSLValue)
		setTakeProfitSend(tempSendTPValue)
	}, [myTrade?.id])

	return (
		<form onSubmit={() => handleUpdateOpenTrade}>
			<Grid container sx={{ borderTop: '1px solid #F6F7F9', mt: 4, pt: 2 }}>
				<AppOrderItem title={'Order ID'} value={toUpdateOpenTrade}/>
				<SidebarPnlItem toUpdateOpenTrade={toUpdateOpenTrade}/>
				<AppOrderItem title={'Open Date'} value={executionDatePop}/>
				<AppOrderItem title={'Open Price'} value={openPrice} />
				<AppOrderItem
					title={'Direction'}
					inputSx={{'& .value': {color: directionColor} }}
					value={capitalize(myTrade?.position)}
				/>
				<AppOrderItem
					inputSx={{'& .assets-number': {fontSize: '16px', fontWeight: 600, lineHeight: '1.875rem'}}}
					title={'Current Price'}
					value={getAssetNumber(bidRate, bidUp, textColor, redColor, greenColor) || currentPrice}
				/>
				<AppOrderItem title={invTitle} value={toFixedIfNull(invValue, 5)} currency={userCurrency}/>
				<AppOrderItem title={'Trade Size'} value={toFixedIfNull(tradeSize, 5)} />
				<AppOrderItem title={'Lots'} value={myTrade?.leverage}/>
				<AppOrderItem title={'Pip Value'} value={toFixedIfNull(myTrade?.pipValueServer, 5)} />
			</Grid>
			<SidebarInitActionsSlTp
				setTakeProfitSend={setTakeProfitSend}
				setStopLossSend={setStopLossSend}
				takeProfitUpdate={takeProfitUpdate}
				stopLossUpdate={stopLossUpdate}
				stopLossAmount={stopLossAmount}
				takeProfitAmount={takeProfitAmount}
				isOpenTradeTab={true}
				updateSlTp={updateSlTpCreateOpen}
				buy={false}
				position={myTrade?.position}
				assetId={myTrade?.assetId}
				myId={myTrade?.id}
				lastPrice={myTrade?.executionEntryRate}
			/>
			<AppButton
				onClick={() => setIsShowPopup(true)}
				title={'Close Trade'}
				inputSx={{
					':hover': {background: theme.palette.red, opacity: 0.7},
					background: theme.palette.red,
					mb: '20px',
					textTransform: 'capitalize'
				}}
			/>
			<AppButton
				onClick={handleUpdateOpenTrade}
				title={'Update'}
				inputSx={{ textTransform: 'capitalize'}} />
			{!isShowPopup ?
				null :
				<AppPopup
					onAction={() => handleCancelOpen(
						dispatch,
						setCancelOpenAction(myTrade?.id, accessToken, isAuthorized),
						alert, t
					)}
					setOpenedComponent={setIsShowPopup}
					title={'Close Trade'}
					text={'Are you sure. You want to close trade?'}
					actionTitle={'Close'}
				/>
			}
		</form>
	)
}

SidebarUpdateOpenTrade.propTypes = {
	toUpdateOpenTrade:  PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
}

export default SidebarUpdateOpenTrade
